import { isNumber } from '@/utils/checks'
import { FeedProperty, FeedOptions } from '@/types/models/Feed.model'
export const getLocalBlockLengthFromFeedLayout = (
  feedLayout: FeedProperty[]
) => {
  const localBlock = feedLayout.find(
    (item) => item.feedType === FeedOptions.Local
  )
  if (localBlock && isNumber(localBlock.maxItems)) {
    return localBlock.maxItems
  }
  return 0
}
